import { Directive, inject, OnInit, signal } from '@angular/core';
import { DocumentService } from '../services/document-service';
import { DocumentItem } from './interfaces';

@Directive() // Fondamentale per far funzionare l'ereditarietà in Angular
export abstract class Document implements OnInit {
  isLoading = signal(true);
  hasError = signal(false);
  loadingMessage = signal('Caricamento documenti...');
  documents = signal<DocumentItem[]>([]);

  // Usiamo 'protected' così le classi figlie possono leggere il service
  protected readonly documentService = inject(DocumentService);
  
  // Costringiamo le classi figlie a dichiarare il loro status
  abstract status: string; 

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading.set(true);
    this.hasError.set(false);

    this.documentService.getDocuments(this.status).subscribe({
      next: (data) => {
        this.documents.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error(`Errore durante il recupero dei documenti (${this.status}):`, err);
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    });
  }
}